<template>
  <div class="about w-full sm:w-3/5 md:w-2/5 mx-auto mt-4">
    <h1
      class="text-center font-display text-xl text-pink-400 mb-6"
    >{{ id ? 'Edit' : 'Add' }} transaction</h1>

    <div v-if="!customAmount" class="w-4/5 mx-auto block mb-4">
      <label for="amount">Amount</label>
      <RadioInput v-model="amount" :options="amounts" name="amount" default="30" />
    </div>

    <div v-else class="w-4/5 mx-auto block mb-4">
      <label for="amount">Amount</label>
      <input type="tel" class="border border-gray-400 py-2 px-2 w-full" v-model="amount" />
      <small v-if="!this.amount" class="text-red-400 mt-1">This field is required</small>
    </div>

    <div class="w-4/5 mx-auto block mb-4">
      <CheckboxInput v-model="customAmount" label="Custom amount" />
    </div>

    <div class="w-4/5 mx-auto block mb-4">
      <label for="amount">Date</label>
      <datetime input-class="border border-gray-400 cursor-pointer py-2 px-2 w-full" v-model="date"></datetime>
    </div>

    <div class="w-4/5 mx-auto block mb-4">
      <label for="amount">Description</label>
      <input type="text" class="border border-gray-400 py-2 px-2 w-full" v-model="description" />
    </div>

    <div class="w-4/5 mx-auto block mb-4">
      <label for="payments">Number of payments</label>
      <RadioInput v-model="paymentsNumber" :options="payments" name="paymentes_number" default="1" />
    </div>

    <div class="w-4/5 mx-auto block mb-4">
      <label for="payments">Type of transaction</label>
      <RadioInput v-model="type" :options="types" name="type" default="income" />
    </div>

    <div class="w-4/5 mx-auto block mb-12 mt-12 text-right">
      <a href="#" class="text-gray-600 text-xs mr-4" @click.prevent="$router.push('/')">Cancel</a>
      <button
        class="bg-teal-400 hover:bg-teal-500 text-white py-2 px-4 rounded focus:outline-none"
        @click="handleTransaction"
        type="button"
      >{{ id ? 'Edit' : 'Add' }}</button>
    </div>
  </div>
</template>

<script>
import RadioInput from "@/components/RadioInput.vue";
import CheckboxInput from "@/components/CheckboxInput";

export default {
  components: {
    RadioInput,
    CheckboxInput
  },
  props: ["id"], // coming from route
  data() {
    return {
      amount: 30,
      amounts: [
        {
          code: 25,
          description: "£25",
          active: false
        },
        {
          code: 30,
          description: "£30",
          active: false
        },
        {
          code: 35,
          description: "£35",
          active: false
        },
        {
          code: 40,
          description: "£40",
          active: false
        },
        {
          code: 50,
          description: "£50",
          active: false
        }
      ],
      date: new Date().toISOString(),
      description: "",
      paymentsNumber: "",
      payments: [
        {
          code: 1,
          description: "1",
          active: false
        },
        {
          code: 2,
          description: "2",
          active: false
        },
        {
          code: 3,
          description: "3",
          active: false
        },
        {
          code: 4,
          description: "4",
          active: false
        }
      ],
      type: "",
      types: [
        {
          code: "income",
          description: "Income",
          active: false
        },
        {
          code: "outcome",
          description: "Expense",
          active: false
        }
      ],
      customAmount: false,
      createdAt: null,
      updatedAt: null,
      storeAction: null
    };
  },
  methods: {
    handleTransaction() {
      if (!this.amount) {
        return false;
      }

      // if we have this.id then we are editing
      if (this.id) {
        this.updatedAt = new Date().toISOString();
      } else {
        this.createdAt = new Date().toISOString();
        this.updatedAt = new Date().toISOString();
      }

      this.$store.dispatch(this.storeAction, this.form).then(() => {
        this.$router.push("/");
      });
    }
  },
  computed: {
    form() {
      return {
        id: this.id ? this.id : null,
        userId: this.user.id,
        amount: +this.amount,
        date: this.date,
        description: this.description,
        paymentsNumber: +this.paymentsNumber,
        type: this.type,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      };
    },
    user() {
      return this.$store.getters.user;
    }
  },
  created() {
    // if we have ID, we are editing - find transaction to edit by ID
    // and set store action
    if (this.id) {
      let transactions = this.$store.getters.transactions;

      let transaction = transactions.find(record => {
        return record.id == this.id;
      });

      if (!transaction) {
        this.$router.push("/");
      }

      let amounts = this.amounts.map(record => {
        return record.code;
      });

      if (amounts.indexOf(transaction.amount) === -1) {
        console.log("custom amount");
        this.customAmount = true;
      }

      setTimeout(() => {
        this.amount = transaction.amount;
        this.date = transaction.date;
        this.description = transaction.description;
        this.type = transaction.type;
        this.createdAt = transaction.createdAt;
        this.updatedAt = transaction.updatedAt;
      }, 100);

      this.storeAction = "editTransaction";
    } else {
      // we are adding new transaction - only set store action
      this.storeAction = "addTransaction";
    }
  }
};
</script>